declare var DocumentTouch;

export function parseHttpHeaders(headers) {
	return headers.split('\n')
		.filter(line => line.startsWith('x-'))
		.map(line => line.split(/: ?/))
		.map(pair => ({ key: pair[0].replace(/^x-/, ''), val: pair[1].trim() }))
		.reduce((obj, pair) => { obj[pair.key] = pair.val; return obj; }, {});
}

export function querystringToObject(querystring) {
	// Adapted from https://stackoverflow.com/a/8649003
	let params = querystring
		.replace(/&/g, '","')
		.replace(/=/g, '":"')
		.replace(/\+/g, '%20');

	return JSON.parse(`{"${params}"}`, (key, value) => {
		if (key === '') return value;
		return decodeURIComponent(value);
	});
}

export function isIE11() {
	return !!window['MSInputMethodContext'] && !!document['documentMode'];
}

export function isTouchInterface() {
	if ('ontouchstart' in window) return true;
	if (window['DocumentTouch'] && document instanceof DocumentTouch) return true;

	let matchMedia: any = window['matchMedia'] || window['msMatchMedia'];
	if (!matchMedia) return false;

	let prefixes = ['-webkit-', '-moz-', '-o-', '-ms-'];
	let query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
	return matchMedia(query).matches;
}
